<template>
  <v-container class="container">
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col>
            <v-menu
            ref="menuFechaCarga"
            v-model="menuFechaCarga"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="width: 50%;"
                outlined
                v-model="fechaCarga"
                label="Selección fecha de carga"
                persistent-hint
                append-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaCarga"
              no-title
              @input="menuFechaCarga = false"
            ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col>
            <v-text-field
            v-model="folioFilter"
            type="number"
            label="folio"

            ></v-text-field>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" @click="getEgresos()" class="d-flex justify-end">Consultar estado</v-btn>
          </v-col>

        </v-row>
        <div class="mb-3 d-flex justify-end">
        </div>
        <ModalEstadoEgreso
          v-if="showDialog"
          @closeDialog="closeDialog"
          :statusDialog="showDialog"
        />
        <div>
          <v-data-table
            :headers="headers"
            :items="egresos"
            :items-per-page.sync="limit"
            :page.sync="offset"
            :server-items-length="total"
            class="caption"
            @pagination="getEgresos()"
          >
          <template v-slot:[`item.nombre`]="{ item }">
            {{ item.nombrebeneficiario  }} {{ item.apellidopaternobeneficiario }}
          </template>
          <template v-slot:[`item.nombres_candidato`]="{ item }">
            {{ item.nombre  }} {{ item.apellidopaterno }}
          </template>
          <template v-slot:[`item.rut`]="{ item }">
              {{ item.rutbeneficiario }}-{{ item.dvbeneficiario }}
            </template>
          <template v-slot:[`item.verdetalle`]="{ item }">
            <div class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="black"
                    style="font-size: 35px;"
                    @click="openDialog(item)"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-card-search-outline</v-icon
                  >
                </template>
                <span>Ver Detalle</span>
              </v-tooltip>
            </div>
          </template>
          </v-data-table>
        </div>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" @click="descargarExcel()" class="d-flex justify-end">Descargar Lista</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations , mapGetters} from "vuex";
import ModalEstadoEgreso from "./ModalEstadoEgreso.vue";
import {EgresosService} from "../../util/Api/Egresos/calls"
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx/xlsx.mjs';

export default {
  name: "EstadoEgresoComponents",
  components: {
    ModalEstadoEgreso,
  },
  data() {
    return {
      status: false,
      showDialog: false,
      menuFechaCarga: false,
      fechaCarga: null,
      total:0,
      limit:10,//la cantidad
      offset:1,//la pagina
      subdireccionFilter:null,
      folioFilter:null,

      headers: [
        { text: "BENEFICIARIO", value: "nombre"  },
        { text: "RUT", value: "rut" },
        { text: "TIPO MONEDA", value: "idtipomoneda" },
        { text: "MONTO EGRESO", value: "montopago" },
        { text: "CANDIDATO O PARTIDO", value: "nombres_candidato" },
        { text: "FECHA ENVIO", value: "fechaenvio" },
        { text: "N° DE PAGO", value: "numeroordenpago" },
        { text: "SUBDIRECCIÓN", value: "subdireccion" },
        { text: "ESTADO", value: "estado" },
        { text: "VER DETALLE", value: "verdetalle" },
      ],
      egresos: [],
    };
  },
  computed: {
      ...mapGetters(["getPerfil"]),
    },
  methods: {
    ...mapMutations("estadoEgreso", ["setDetalle"]),
    openDialog(data) {
    console.log(data);
      this.setDetalle(data);
      this.showDialog = true;
    },
    closeDialog(status) {
      this.showDialog = status;
    },

    async getEgresos(){
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const params={
          idsubdireccion:this.getPerfil.subdireccion_id,
          limit:this.limit !==-1 ? this.limit : 999999 ,//la cantidad
          offset: this.limit !==-1 ? (this.offset-1)*this.limit : 0,//la pagina-1 * limit pa
          fromDate:this.fechaCarga ? `${this.fechaCarga}T00:00:00.000Z`: null,
          toDate:this.fechaCarga ? `${this.fechaCarga}T23:59:59.999Z`: null,
          folio:this.folioFilter,
        }

        this.egresos = await EgresosService.getAll(params);

        this.egresos.length ? this.total= Number(this.egresos[0].total) : null
        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los Egresos: ${error}`,
        });
      }
    },

    async descargarExcel(){

      let name = "Egresos";
      if (this.getPerfil && this.getPerfil.subdireccion_id) {
        name += `-Sub${this.getPerfil.subdireccion_id}`;
      }
      if (this.fechaCarga) {
        name += `-${this.fechaCarga}`;
      }
      if (this.folioFilter) {
        name += `-${this.folioFilter}`;
      }
      name= `${name}.xlsx`;

      const ws = XLSX.utils.json_to_sheet(this.egresos);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Egresos");

      XLSX.writeFile(wb, name);

    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
